import { CommonGridToolBarWithFilterText, CommonGridToolBarWithFilterTextCustom } from '../../../Components/Common Components/CommonComponents';
import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Checkbox, IconButton, TextField, CircularProgress, Box, Typography, Tooltip, FormControl, RadioGroup, Radio, FormControlLabel, Drawer, Stack, Button, Autocomplete } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Colors } from "../../../Styles/Colors";
import { ImagePaths } from "../../../Utility/ImagePaths";
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import { AmountsCard } from '../../../Components/CommonCards/CommonCards';
import CommonDatePicker from '../../../Components/Common Components/CommonDatePicker';
import { DateTime } from 'luxon';
import { formatDate } from '../../../Components/CommonFunctions/CommonFunctions';

const datelist = {
  fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
  toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
  dateIndex: 1,
  selectlocation: null,
  selectCategory: null,
}

const StoreShortExpiry = () => {
  const [page, setpage] = useState(0);
  const [pageSize, setpageSize] = useState(10);
  const [stockValue, setstockValue] = useState([]);
  const [isloader, setisloader] = useState(false);
  const [filterOpen, setFilterOpen] = useState(false);
  const [errorMsg, seterrorMsg] = useState(false);
  const [errorMsgText, seterrorMsgText] = useState('');
  const [successMsg, setsuccessMsg] = useState(false);
  const [successMsgText, setsuccessMsgText] = useState('');
  const [filterData, setfilterData] = useState(datelist);
  const [SubLocationList, setSubLocationList] = useState([]);


  useEffect(() => {
    getStoreStockValue()
    getSubLocationList()
  }, [])

  const errorMessage = (msg) => {
    seterrorMsgText(msg)
    seterrorMsg(true)
  }
  const successMessage = (msg) => {
    setsuccessMsgText(msg)
    setsuccessMsg(true)
  }

  const generateUrl = (addQuery = "") => {
    let url = Serviceurls.STORE_EXPIRY_ALERT + `?from_date=${filterData.fromDate}&to_date=${filterData.toDate}&sub_location=${filterData.stklocation?.id || ''}`;
    if (addQuery) {
      url += addQuery
    }
    return url
  }

  const getStoreStockValue = () => {
    try {
      setisloader(true)
      const url = generateUrl();
      RestAPIService.getAll(url)
        .then((response) => {
          if (response.data.status === 'success') {
            setstockValue(response.data.data || [])
            setisloader(false)
          }
        }).catch(e => {
          setisloader(false)
          if (e?.response?.data?.message) {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      setisloader(false)
      errorMessage(e.message)
    }
  }

  const getStoreShortPrint = () => {
    const url = generateUrl("&export_type=pdf");
    try {
      RestAPIService.getAllPrint(url)
        .then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }).catch((error) => {
          errorMessage(error?.response?.data?.message || error?.message)
        })
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const getSubLocationList = (storeObj = null) => {
    try {
      RestAPIService.getAll(Serviceurls.SUB_LOCATION_CREATION_MASTER + '?only_store=true')
        .then((response) => {
          if (response.data.status === 'success') {
            setSubLocationList(response.data.data || [])
          }
        }).catch(e => {
          if (e?.response?.data?.status === 'fail') {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      errorMessage(e.message)
    }
  }

  const FilterDate = (from, to, index) => {
    setfilterData({ ...filterData, fromDate: from, toDate: to, dateIndex: index })
  }

  const renderFilterScreen = () => {
    return (
      <Box className='eMed_rts_filter_container' >
        <Box className='eMed_filter_Top'>
          <Typography variant='h6' fontWeight={600}>Filter</Typography>
          <Tooltip>
            <Button onClick={() => { setFilterOpen(false) }}>
              <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_Canteen_CloseImg' />
            </Button>
          </Tooltip>
        </Box>
        <Box className='eMed_rts_middle'>
          <Box className='eMed_date_filter'>
            <CommonDatePicker
              FromDate={filterData.fromDate}
              ToDate={filterData.toDate}
              DateIndex={filterData.dateIndex}
              SelectedDates={FilterDate.bind(this)}
              Future={true} />
          </Box>
          <Box className='eMed_rts_dropdown'>
            <Autocomplete
              size='small'
              value={filterData.stklocation}
              options={SubLocationList}
              getOptionLabel={(option) => (typeof (option) === 'string') ? option : option?.sublocation_name}
              onChange={(event, newValue) => {
                setfilterData({ ...filterData, stklocation: newValue })
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={'Select SubLoction'}
                />
              )} />
          </Box>
        </Box>
        <Box>
          <Stack spacing={2} direction="row" justifyContent={'center'}>
            <Button size='small' variant='outlined' className='eMed_Canteen_BtnText' onClick={() => { setfilterData(datelist) }}>Clear</Button>
            <Button size='small' variant='contained' className='eMed_Canteen_BtnText' onClick={() => {
              getStoreStockValue()
              setFilterOpen(false)
            }}>Search</Button>
          </Stack>
        </Box>
      </Box>
    )
  }


  const closeFilter = () => {
    setFilterOpen(false);
  }

  const tableView = () => {
    try {
      const gridToolBar = () => {
        let TextArray = [
          { label: "From Date", value: formatDate(filterData?.fromDate || "") },
          { label: "To Date", value: formatDate(filterData?.toDate || "") },
          { label: "Stock", value: filterData?.stklocation?.sublocation_name || "Store" },
        ]
        return (
          <Box>
            <CommonGridToolBarWithFilterText FilterTextArray={TextArray} />
          </Box>
        )
      }
      stockValue?.forEach((element, index) => element.sno = index + 1)
      const columns = [
        // {
        //   field: 'sub_location', headerName: 'Sub Location', flex: 0.07,
        //   renderCell: (params) => (<Box component={'div'}>{params?.row?.sub_location || '-'}</Box>)

        // },
        {
          field: 'product_code', headerName: 'Product Code', flex: 0.07,
          renderCell: (params) => (<Box component={'div'}>{params?.row?.product_code || '-'}</Box>)

        },
        {
          field: 'product_name', headerName: 'Product Name', flex: 0.07,
          renderCell: (params) => (params.row.product_name ? params.row.product_name?.length > 12 ?
            <Tooltip placement="top" title={params.row.product_name}><Typography fontSize={'0.9vw'}>{params.row.product_name?.slice(0, 12) + '...'}</Typography></Tooltip> :
            <Typography fontSize={'0.9vw'}>{params.row.product_name || '-'}</Typography> : '-')
        },
        {
          field: 'category_name', headerName: 'Category', flex: 0.07,
          renderCell: (params) => (params.row.category_name ? params.row.category_name?.length > 12 ?
            <Tooltip placement="top" title={params.row.category_name}><Typography fontSize={'0.9vw'}>{params.row.category_name?.slice(0, 12) + '...'}</Typography></Tooltip> :
            <Typography fontSize={'0.9vw'}>{params.row.category_name || '-'}</Typography> : '-')

        },
        {
          field: 'batch_no', headerName: 'Batch Number', flex: 0.07,
          renderCell: (params) => (<Box component={'div'}>{params?.row?.batch_no || '-'}</Box>)

        },
        {
          field: 'expiry_date', headerName: 'Expiry Date', flex: 0.07,
          renderCell: (params) => (<Box component={'div'}>{params?.row?.expiry_date ? formatDate(params?.row?.expiry_date, true) : '-'}</Box>)

        },
        {
          field: 'stock_in_quantity', headerName: 'Quantity', flex: 0.07,
          renderCell: (params) => (<Box component={'div'}>{params?.row?.stock_in_quantity || '0'}</Box>)

        },
        {
          field: 'stock_value', headerName: 'Value', flex: 0.07,
          renderCell: (params) => (<Box component={'div'}>{params?.row?.stock_value || '0'}</Box>)

        },
      ];
      return (
        <Box sx={{ height: '67vh', marginTop: '.5vw', backgroundColor: 'white' }}>
          <DataGrid
            rows={stockValue}
            columns={columns}
            getRowId={(row) => row['sno']}
            page={page}
            pageSize={pageSize}
            localeText={{
              toolbarColumns: "",
              toolbarDensity: "",
              toolbarExport: "",
              toolbarFilters: "",
              toolbarExportPrint: ""
            }}
            components={{
              Toolbar: gridToolBar,
              NoRowsOverlay: () => (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                  {'No Records To Be Shown'}
                </Box>
              )
            }}
            onPageChange={(newPage) => { setpage(newPage) }}
            onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
            rowsPerPageOptions={[10, 20, 30]}
            pagination
            headerHeight={40}
            density='standard'
            disableSelectionOnClick
            loading={isloader}
          />
        </Box>
      )
    } catch (e) {

    }
  }

  const msgClose = () => {
    seterrorMsg(false)
    seterrorMsgText("")
    setsuccessMsg(false)
    setsuccessMsgText("")
  }

  return (
    <Box sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
      <Box display={'flex'} justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
        <Box display={'flex'} flexDirection={'row'} marginLeft={'-.8vw'}>
          {AmountsCard('Total Products', stockValue?.length, true)}
        </Box>
        <Box>
          <IconButton onClick={() => { setFilterOpen(true) }}>
            <img style={{ width: '2vw', height: '2vw' }} src={ImagePaths.Filter.default} alt='filter' />
          </IconButton>
          <IconButton onClick = {getStoreShortPrint}>
            <img style={{ width: '2vw', height: '2vw' }} src={ImagePaths.LabPrintIcon.default} alt='filter' />
          </IconButton>
          {/* <IconButton>
            <img style={{ width: '2vw', height: '2vw' }} src={ImagePaths.ExportIcon.default} alt='filter' />
          </IconButton> */}
        </Box>
      </Box>
      <Box>
        {tableView()}
      </Box>
      <Drawer
        anchor={'right'}
        open={filterOpen}
        ModalProps={{ onBackdropClick: closeFilter }}
      >
        {renderFilterScreen()}
      </Drawer>
      {errorMsg ?
        <ToastMsg
          severity={'error'}
          msg={errorMsgText}
          msgPop={msgClose.bind(this)}
        />
        : null}
      {successMsg ?
        <ToastMsg
          severity={'success'}
          msg={successMsgText}
          msgPop={msgClose.bind(this)}
        />
        : null}
    </Box>
  );
}

export default StoreShortExpiry